import React, { Component } from 'react';

export default class MyTripsList extends Component {

  renderList() {
    const { myTripsData, renderItem } = this.props;

    if (myTripsData.length === 0) {

      return (
        <div>
          <div className="list-group">
            <div className="list-item">
              <div className="inner">
                <div className="no-trips">No upcoming trips</div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div key="listGroup">
        <div className="list-group">
          {myTripsData.map((myTrip, key) => {
            if (myTripsData.length > 1 && key + 1 < myTripsData.length) {
              return renderItem(myTrip, true);
            }
            return renderItem(myTrip);
          })}
        </div>
      </div>
    );
  }

  render() {
    const { myTripsData, isLoading } = this.props;

    if (!Array.isArray(myTripsData) || (myTripsData.length === 0 && isLoading)) {
      // Could display a loading spinner but parent is handling this for now
      return <span />;
    }

    return (
      <section className="full-screen-list">
        {this.renderList()}
      </section>
    );
  }
}

MyTripsList.defaultProps = {
  isLoading: true,
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/MyTripsList.js